/* Pferdegold – Deals-Announcement-Bar: Countdown
   Liest data-end ("JJJJ-MM-TT HH:MM" oder ISO) und schreibt Tage/Std/Min/Sek in [data-pgd]. */
(function () {
  'use strict';

  function parseEnd(str) {
    if (!str) return NaN;
    var s = str.trim();
    // "2026-10-31 23:59" -> "2026-10-31T23:59" (lokale Zeit des Besuchers)
    if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}/.test(s)) s = s.replace(' ', 'T');
    var t = new Date(s).getTime();
    return isNaN(t) ? NaN : t;
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  // Position "Unter dem Suchfeld": auf Mobil/Tablet (Suchfeld als eigene Zeile, bis 1366 px) wird die Bar
  // als Anhänger direkt unter das Suchfeld gehängt (gleiche Breite). Auf breitem Desktop (Suchfeld inline)
  // kommt sie unter die Logo-Zeile. Findet das Script den Header nicht, bleibt die Bar ganz oben.
  var belowSearchMq = window.matchMedia('(max-width: 1366px)');

  function placeTarget() {
    var below = document.querySelector('main-header#site-header .header-search-below');
    if (below && belowSearchMq.matches) return { el: below, mode: 'attached' };
    var top = document.querySelector('main-header#site-header .header-container--top');
    if (top) return { el: top, mode: 'after' };
    return null;
  }

  // Theme-Editor: beim Neu-Rendern der Section bleibt eine bereits verschobene Bar im Header stehen → entfernen.
  // Gilt für jede Position, auch wenn gerade von "Unter dem Suchfeld" zurück auf "Ganz oben" geschaltet wird.
  function removeStale(bar) {
    if (!bar.id) return;
    document.querySelectorAll('.pg-deals--placed').forEach(function (old) {
      if (old !== bar && old.id === bar.id) old.remove();
    });
  }

  function place(bar) {
    if (bar.dataset.pgdPlace !== 'below-search') return;
    var t = placeTarget();
    if (t && t.mode === 'attached') {
      if (bar.parentNode !== t.el) t.el.appendChild(bar);
      bar.classList.add('pg-deals--attached');
    } else if (t) {
      if (t.el.nextElementSibling !== bar) t.el.insertAdjacentElement('afterend', bar);
      bar.classList.remove('pg-deals--attached');
    }
    bar.classList.add('pg-deals--placed');
  }

  function placeAll() {
    document.querySelectorAll('.pg-deals[data-pgd-place]').forEach(place);
  }
  if (belowSearchMq.addEventListener) belowSearchMq.addEventListener('change', placeAll);

  function init(bar) {
    if (!bar) return;
    removeStale(bar);
    place(bar);
    if (bar.dataset.pgdInit === '1') return;
    bar.dataset.pgdInit = '1';

    var end = parseEnd(bar.getAttribute('data-end'));
    var countdown = bar.querySelector('.pg-deals__countdown');
    var expiredEl = bar.querySelector('.pg-deals__expired');
    if (!countdown || isNaN(end)) return;

    var els = {
      d: countdown.querySelector('[data-pgd="d"]'),
      h: countdown.querySelector('[data-pgd="h"]'),
      m: countdown.querySelector('[data-pgd="m"]'),
      s: countdown.querySelector('[data-pgd="s"]')
    };
    var hideExpired = bar.getAttribute('data-hide-expired') === 'true';
    var expiredText = bar.getAttribute('data-expired-text') || '';
    var timer = null;

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        clearInterval(timer);
        if (hideExpired) {
          bar.hidden = true;
        } else {
          countdown.hidden = true;
          if (expiredEl) { expiredEl.textContent = expiredText; expiredEl.hidden = false; }
        }
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (els.d) els.d.textContent = pad(d);
      if (els.h) els.h.textContent = pad(h);
      if (els.m) els.m.textContent = pad(m);
      if (els.s) els.s.textContent = pad(s);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('.pg-deals').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme-Editor: Section wird neu gerendert bzw. entfernt
  document.addEventListener('shopify:section:load', function (e) {
    var bar = e.target && e.target.querySelector ? e.target.querySelector('.pg-deals') : null;
    if (bar) init(bar);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var id = e.target && e.target.id ? e.target.id.replace('shopify-section-', '') : '';
    if (!id) return;
    document.querySelectorAll('.pg-deals--placed').forEach(function (old) {
      if (old.id === 'pg-deals-' + id) old.remove();
    });
  });
})();
